function ServiceConfigurationPage() {
    /**
     *
     */
    ServiceConfigurationPage.prototype.initialize = function (console, service) {
        this.id = "serviceConfiguration";
        this.console = console;

        if (service) {
            this.serviceId = service.id;
            this.service = this.console.consoleService
                .filterTransient(service);

            Service.bind(this.console.node, this.service);

            this.serviceType = this.service.type;
        }
        else {
            this.service = Service.create(this.console.node);
            this.serviceType = 'stateSnapshot';
        }

        return this;
    };

    /**
     *
     */
    ServiceConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.nodeConfigurationScope = 2;

        this.deviceFlags = {};
        this.actorFlags = {};
        this.sensorFlags = {};
        this.sensors = [];
        this.actors = [];

        for (var m = 0; m < this.console.node.devices.length; ++m) {
            this.deviceFlags[this.console.node.devices[m].id] = {flag: false, device: this.console.node.devices[m]};

            for (var l = 0; l < this.console.node.devices[m].actors.length; ++l) {
                this.actors.push(this.console.node.devices[m].actors[l]);
                this.actorFlags[this.console.node.devices[m].actors[l].fullId()] = {
                    flag: false,
                    actor: this.console.node.devices[m].actors[l]
                };
            }

            for (var l = 0; l < this.console.node.devices[m].sensors.length; ++l) {
                this.sensors.push(this.console.node.devices[m].sensors[l]);
                this.sensorFlags[this.console.node.devices[m].sensors[l].fullId()] = {
                    flag: false,
                    sensor: this.console.node.devices[m].sensors[l]
                };
            }
        }

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    ServiceConfigurationPage.prototype.generateScript = function () {
        var script = "";

        for (var n in this.deviceFlags) {
            if (this.deviceFlags[n].flag) {
                script += this.deviceFlags[n].device.id;
                script += ".setState(";
                script += JSON.stringify(this.console.consoleService.filterTransient(this.deviceFlags[n].device._state));
                script += ");";
            }
        }

        for (var n in this.actorFlags) {
            if (this.actorFlags[n].flag) {
                script += this.actorFlags[n].actor.fullId();
                script += ".setState(";
                script += JSON.stringify(this.console.consoleService.filterTransient(this.actorFlags[n].actor._state));
                script += ");";
            }
        }

        return script;
    };

    /**
     *
     */
    ServiceConfigurationPage.prototype.createService = function () {
        if (this.serviceType === "stateSnapshot") {
            this.service.type = "script";
            this.service.content.script = this.generateScript();
        }

        this.console.consoleService.createService(this.console.node, this.service).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to add Service.", "error");
        }.bind(this));
    };

    /**
     *
     */
    ServiceConfigurationPage.prototype.updateService = function () {
        this.console.consoleService.updateService(this.console.node, this.service).done(function (node) {
            this.console.bindNode(node);
            this.console.popPage();
        }.bind(this)).fail(function (error) {
            console.error(error);
            this.console.openMessageDialog("Failed to change Service.", "error");
        }.bind(this));
    };

    /**
     *
     */
    ServiceConfigurationPage.prototype.leave = function () {
    };
}
